import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import UserApi from "src/store/apis/Token";
import authSlice from "src/store/slices/auth";
import BaseApi from "src/store/apis/BaseApi";
import timerReducer from "./slices/timer";
import clientSlice from "./slices/client";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    timer: timerReducer,
    client: clientSlice,
    [UserApi.reducerPath]: UserApi.reducer,
    [BaseApi.reducerPath]: BaseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(UserApi.middleware, BaseApi.middleware);
  },
});

setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
